module.exports = __webpack_public_path__ + "media/images/new_culture/bg-9-faf86688f3d38aae0a42e9b9baba8fd9.jpeg";